import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/**
 * The Blocks OS gateway names query operations `get<Collection>`, and pluralizes by the literal
 * schema name + "s" (`CtcLevel` -> `CtcLevels`). Aliased so services and hooks read
 * `result.CtcLevels`, matching the read-only lookup the employee wizard already uses
 * (`src/modules/hr-directory/graphql/basic-info-lookups.ts`).
 *
 * Lowest CTC first by default, so levels read as a ladder. The old app had no CTC level manager (its
 * read-only list used the collection's natural order), so this sort is the new screen's own.
 */
export const DEFAULT_CTC_LEVELS_ORDER: OrderBy[] = [{ field: 'CTC', direction: 'ASC' }];

export const buildGetCtcLevelsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_CTC_LEVELS_ORDER
) => `
  query {
    CtcLevels: getCtcLevels(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        Level
        CTC
        Ranks
      }
    }
  }
`;
